<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="userAvator || oem.icon" />
      </Badge>

      <Icon :size="18"
            type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px"
                 :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <!-- <DropdownItem name="reset_password">修改密码</DropdownItem> -->
        <DropdownItem name="logout">退出登录</DropdownItem>
        <!-- <DropdownItem name="sales">前台收银</DropdownItem> -->
      </DropdownMenu>
    </Dropdown>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           width="400"
           title="修改密码">
      <Form ref="account"
            :label-width="120">
        <Form-item label="原密码"
                   prop="origin_password">
          <Input type="password"
                 v-model="origin_password" />
        </Form-item>
        <Form-item label="新密码"
                   prop="password">
          <Input type="password"
                 v-model="password" />
        </Form-item>
        <Form-item label="确认密码"
                   prop="password2">
          <Input type="password"
                 v-model="password2" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import './user.less'
import { mapActions, mapGetters, mapState } from 'vuex'
// import logo from '@/assets/images/logo.png'
export default {
  name: 'User',
  data () {
    return {
      modalShow: false,
      origin_password: '',
      password: '',
      password2: ''
    }
  },
  mounted () {
    this.getUserInfo()
  },
  computed: {
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem'])
  },
  props: {
    userAvator: {
      type: String,
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapActions('editor', ['getUserInfo', 'logout', 'change_pwd']),
    handleSubmit () {
      if (this.password !== this.password2) {
        this.$Message.error('两次密码不一样')
        return
      }
      this.change_pwd({
        origin_password: this.origin_password,
        new_password: this.password
      })
      this.modalShow = false
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.logout()
          break
        case 'message':
          // this.message()
          this.$router.push(`/messages`)
          break
        case 'reset_password':
          this.modalShow = true
          break
      }
    }
  }
}
</script>
